const constants = {
  apiHost: process.env.REACT_APP_API_HOST,
  apiAuthHost: process.env.REACT_APP_AUTH_API_HOST,
  tradersApiHost: process.env.REACT_APP_TRADERS_API_HOST,
  tradersApiAuthHost: process.env.REACT_APP_TRADERS_AUTH_API_HOST,
  env: process.env.REACT_APP_ENV,
};

export default constants;
